import React from 'react';
import { Navigate } from 'react-router-dom';
import { CircularProgress, Box } from '@mui/material';
import { useAuth } from '../contexts/AuthContext';

interface Props {
  children: React.ReactElement;
  /** Si se especifica, solo ese rol puede acceder. Sin valor = cualquier usuario autenticado. */
  rol?: 'admin' | 'abogado';
}

export default function ProtectedRoute({ children, rol }: Props) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="60vh">
        <CircularProgress />
      </Box>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (rol && user.rol !== rol) {
    return <Navigate to="/" replace />;
  }

  return children;
}
